var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeColorfulIcon = function SvgYoutubeColorfulIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 24 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE1312",
    fillRule: "evenodd",
    d: "M9.522 12.32V5.128l6.484 3.607zM23.76 3.882s-.235-1.764-.954-2.54C21.893.323 20.87.318 20.401.259 17.043 0 12.005 0 12.005 0h-.01S6.957 0 3.599.26c-.47.058-1.492.063-2.406 1.083-.719.776-.953 2.54-.953 2.54S0 5.954 0 8.025v1.941c0 2.072.24 4.142.24 4.142s.234 1.764.953 2.54c.914 1.02 2.113.988 2.647 1.094C5.76 17.94 12 18 12 18s5.043-.008 8.401-.267c.47-.06 1.492-.065 2.405-1.085.72-.776.954-2.54.954-2.54s.24-2.07.24-4.142V8.025c0-2.07-.24-4.142-.24-4.142"
  })));
};
export default SvgYoutubeColorfulIcon;